/**
 * Central resolver for artwork image URLs.
 *
 * Assets live in the Hungru public S3 bucket (`hungru-public`) under
 * `shanir_arts/studio/` and are served through the Cloudflare CDN at
 * `https://hungru.co/hungru-public/shanir_arts/studio/...`.
 *
 * Publish pipeline: `npm run publish-arts` (desktop → WebP → S3; no local copies).
 *
 * Override the base at build time with `REACT_APP_ART_CDN_BASE`:
 *   - unset      → CDN (default)
 *   - custom URL → direct S3 or another mirror
 */
const DEFAULT_CDN_BASE = "https://hungru.co/hungru-public/shanir_arts/studio";

const configuredBase = process.env.REACT_APP_ART_CDN_BASE;
const CDN_BASE = (configuredBase ?? DEFAULT_CDN_BASE).replace(/\/+$/, "");

/** Build an artwork URL from a bucket-relative path like `ai-arts/foo.webp`. */
export function artAsset(path: string): string {
  const clean = path.replace(/^\/+/, "");
  const encoded = clean.split("/").map(encodeURIComponent).join("/");
  return CDN_BASE ? `${CDN_BASE}/${encoded}` : `/${encoded}`;
}
